<template>
	<div>
		<GenericSelector 
			:value="value"
			@input="val => $emit('input', value)"
			:options="options" 
            displayKey="path"
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="loading || loadingOptions"
            @click="val => $emit('selectItem', value)"
		>
			<template v-slot:unselectedHeader>
				<div class="clearfix my-2">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" class="float-left" />
					<button 
						type="button" 
						@click="showOptions = !showOptions"
						class="btn float-right" 
						:class="showOptions ? 'btn-secondary' : 'btn-primary'"
                        v-if="canEdit"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: { 
		GenericSelector,
		SearchBar,
	},
    props: {
		value: Array,
		loading: {
			type: Boolean,
			default: false
		},
        canEdit: {
            type: Boolean,
            default: false
        },
        availableNodes: Array
	},
    data() {
        return {
            showOptions: false,
			loadingOptions: false,
			search: '',
        };
    },
    mounted() {
    },
    methods: {
    },
    computed: {
		options() {
            if(this.availableNodes){
                return this.availableNodes.filter(node => !this.search || node.path.toLowerCase().includes(this.search.toLowerCase()))
            } else {
                return [];
            }
		}
    },
};
</script>
